/* eslint @typescript-eslint/strict-boolean-expressions: off */

import Link from "next/link";
import React from "react";
import { Cell } from "gui/grid/cell";
import { DashboardList } from "gui/entries/dashboard-list";
import { FullDashboard } from "lib/entries/types";
import { Grid } from "gui/grid/grid";
import { Icon } from "gui/icon/icon";
import { Spacer } from "gui/spacer/spacer";
import { Subtitle } from "gui/subtitle/subtitle";
import { useRelatedDashboards } from "lib/entries/hooks";

export const RelatedDashboards: React.FC<{
  dashboard: FullDashboard;
}> = (props) => {
  const related = useRelatedDashboards(props.dashboard);

  if (related.error) {
    throw related.error;
  }

  if (!related.data) {
    return null;
  }

  if (related.data.length === 0) {
    return null;
  }

  return (
    <Grid gaps>
      <Spacer />
      <Subtitle text="Related dashboards" icon="search">
        <Link
          href="/browse/[slug]"
          as={`/browse/dashboards?q=${props.dashboard.name}`}
          prefetch={false}
        >
          <a>
            ... and more
            <Icon icon="arrow-right" />
          </a>
        </Link>
      </Subtitle>
      <Cell>
        <DashboardList entries={related.data} color2 avatar favorites />
      </Cell>
    </Grid>
  );
};
